/* eslint-disable camelcase */
import Bowser from "bowser";

const userAgent = Bowser.parse( window.navigator.userAgent );

import { ActivityType } from "@teaming/common-enums";

export default ( { amplitude, foundation, } ) => {
	return {
		emailSignUpClicked() {
			amplitude.event( "Sign-up with Email Clicked" );
		},
		emailSignUpSubmitted( emailAddress ) {
			amplitude.event( "Sign - up with Email address submitted", {
				email_address: emailAddress,
			} );
		},
		signUpPageViewed() {
			amplitude.event( "Sign-up Page Viewed", {
				location: "Sign-up",
			} );
		},
		signInPageViewed() {
			amplitude.event( "Sign-in Page Viewed", {
				location: "Sign-in",
			} );
		},
		async signingIn() {
			const { ioUser, } = foundation();
			try {
				await ioUser.activity( {
					activityType: ActivityType.USER_LOGIN,
					metadata: userAgent,
				} );
			} catch ( e ) {
				// intentionally empty
			}
		},
		async signingOut() {
			const { ioUser, } = foundation();
			try {
				await ioUser.activity( {
					activityType: ActivityType.USER_LOGOUT,
					metadata: userAgent,
				} );
			} catch ( e ) {
				// intentionally empty
			}
		},
		signInCompleted() {
			amplitude.event( "Sign-in Completed" );
		},
		signInFailed( reason ) {
			amplitude.event( "Sign-in Failed", {
				reason,
			} );
		},
		signUpCompleted() {
			amplitude.event( "Sign-up Completed" );
		},
		signUpFailed( reason ) {
			amplitude.event( "Sign-up Failed", {
				reason,
			} );
		},
	};
};
